import React from "react";

const NotFounds = () => {
  return (
    <div className="text-center">
      <img
        src="https://static.vecteezy.com/system/resources/previews/002/416/606/non_2x/404-error-and-page-not-found-illustration-vector.jpg"
        alt=""
      />
    </div>
  );
};

export default NotFounds;
